module.exports = __webpack_public_path__ + "img/bg9.48d0ba09.png";